export const cloverColorTheme = {
  Main: {
    primaryColor: "#228800",
    secondaryColor: "#226600",
  },
};
